import pilotContent from '../data/pilotProductContent.json';

const PILOT_ALIASES = {
  'orchid-fertilizer': 'orchid-plant-food',
  'arborvitae-tree-fertilizer': 'arborvitae-fertilizer',
};

export function parseMetafield(value) {
  if (!value) return null;
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

function getPilotEntry(handle) {
  if (pilotContent[handle]) return pilotContent[handle];
  const aliasHandle = PILOT_ALIASES[handle];
  return aliasHandle ? pilotContent[aliasHandle] : null;
}

export function resolveProductContent(handle, contentFields) {
  const meta = contentFields || {};
  const pilot = getPilotEntry(handle);

  const openingParagraph =
    parseMetafield(meta.opening_paragraph) ||
    pilot?.openingParagraph ||
    null;

  const howToUse =
    parseMetafield(meta.how_to_use) ||
    pilot?.howToUse ||
    null;

  const howToUseNote =
    parseMetafield(meta.how_to_use_note) ||
    pilot?.howToUseNote ||
    null;

  const whatsInside =
    parseMetafield(meta.whats_inside) ||
    pilot?.whatsInside ||
    null;

  const madeFor =
    parseMetafield(meta.made_for) ||
    pilot?.madeFor ||
    null;

  const problemsItSolves =
    parseMetafield(meta.problems_it_solves) ||
    pilot?.problemsItSolves ||
    null;

  const faqs =
    parseMetafield(meta.faqs) ||
    pilot?.faqs ||
    null;

  const relatedProducts =
    parseMetafield(meta.related_products) ||
    pilot?.relatedProducts ||
    null;

  // Plain-text metafields pointing a PDP at its matching blog guide. Only a
  // site-relative or absolute URL is honored, so a malformed value can't
  // produce a broken relative link.
  const guideUrlRaw = typeof meta.related_guide_url === 'string' ? meta.related_guide_url.trim() : null;
  const relatedGuideUrl =
    guideUrlRaw && (guideUrlRaw.startsWith('/') || guideUrlRaw.startsWith('http'))
      ? guideUrlRaw
      : null;
  const relatedGuideTitle =
    typeof meta.related_guide_title === 'string' && meta.related_guide_title.trim()
      ? meta.related_guide_title.trim()
      : null;

  if (!openingParagraph && !howToUse && !whatsInside && !madeFor && !problemsItSolves && !faqs && !relatedGuideUrl) {
    return null;
  }

  return {
    openingParagraph,
    howToUse,
    howToUseNote,
    whatsInside,
    madeFor,
    problemsItSolves,
    faqs,
    relatedProducts,
    relatedGuideUrl,
    relatedGuideTitle,
  };
}

// Heading for the related-guide callout. Titles ending in "Fertilizer" yield
// "New to growing mango tree?"; anything else (Plant Food, supplements) falls
// back to a generic heading rather than guessing badly. Mirrors
// guideCalloutHeading() in scripts/productContentPrerender.js.
export function guideCalloutHeading(productTitle) {
  const match = /^(.+?)\s+fertilizer$/i.exec(String(productTitle || '').trim());
  return match ? `New to growing ${match[1].toLowerCase()}?` : 'New to growing this plant?';
}

// Derives the Care Hub "quick answer" (amount + frequency) from the first
// how_to_use entry - there's no dedicated metafield for this yet.
export function getQuickAnswer(howToUse) {
  if (!Array.isArray(howToUse) || howToUse.length === 0) return null;
  const first = howToUse[0];
  if (!first?.amount && !first?.frequency) return null;
  return {
    amount: first.amount || null,
    frequency: first.frequency || null,
  };
}
